import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import ReactDOM from "react-dom";
import "./SelectCell.scss";

export function SelectCell({ options, selected, setSelected, disabled }) {
  const triggerRef = useRef();
  const ref = useRef();
  const [t] = useTranslation();
  const [openStateList, setOpenStateList] = useState(false);
  const [selectedState, setSelectedState] = useState(selected);
  const [firstTime, setFirstTime] = useState(true);
  const [dropdownPosition, setDropdownPosition] = useState({ left: 0, top: 0 });

  useEffect(() => {
    if (selected !== selectedState) {
      setSelectedState(selected);
    }
  }, [selected]);

  useEffect(() => {
    if (setSelected && firstTime === false) {
      setSelected(selectedState);
    } else {
      setFirstTime(false);
    }
  }, [selectedState]);

  useEffect(() => {
    const handler = (event) => {
      const target = event.target;
      if (openStateList && ref.current && !ref.current.contains(target)) {
        setOpenStateList(false);
      }
    };

    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [openStateList]);

  const handleOpenDropdown = (e) => {
    const rect = triggerRef.current.getBoundingClientRect();
    setDropdownPosition({ left: rect.left, top: rect.bottom });
    setOpenStateList(!openStateList);
  };

  const renderDropDown = () => {
    const rootHelperContainer = document.getElementById("root");
    const vScroll = window.pageYOffset;

    return rootHelperContainer
      ? ReactDOM.createPortal(
          <div
            className={`select-dropdown ${openStateList ? "show" : ""}`}
            style={{
              position: "absolute",
              zIndex: "4",
              left: `${dropdownPosition.left}px`,
              top: `${vScroll + dropdownPosition.top}px`,
            }}
          >
            <div className="select-dropdown-list">
              {options.map((option, i) => (
                <div
                  key={`dropdown-list-${i}`}
                  className="select-item"
                  onClick={() => {
                    setSelectedState(option);
                    setOpenStateList(false);
                  }}
                >
                  {t(option?.name)}
                </div>
              ))}
            </div>
          </div>,
          rootHelperContainer
        )
      : null;
  };

  return (
    <div className={"select-cell"} ref={ref}>
      <div
        ref={triggerRef}
        className={`select ${disabled ? "disabled" : ""}`}
        onClick={(e) => {
          if (!disabled) {
            handleOpenDropdown();
          }
        }}
      >
        {t(selectedState?.name)}
        <div className="icon">keyboard_arrow_down</div>
      </div>
      {renderDropDown()}
    </div>
  );
}
